let getPageName = function (url) {
  if (url && (url[0] === '/' || url.includes('benable.com'))) {
    if (url.includes('/app_invites')) {
      return 'App Invite';
    } else if (url.includes('/discover')) {
      return 'Discover';
    } else if (url.includes('/global_search')) {
      return 'Global Search';
    } else if (url.includes('/dashboard')) {
      return 'Dashboard';
    } else if (url.includes('/bookmarks')) {
      return 'Bookmarks';
    } else if (url.includes('/profiles/')) {
      return 'Profile Edit';
    } else if (url.includes('/i/') || url.includes('/w/')) {
      return 'Landing Page';
    } else if (url.split('/').length == 2) {
      return 'Profile';
    } else if (url.split('/').length == 3) {
      return 'List';
    }
  }

  return null;
};

export default {
  getPageName: getPageName,

  identify: function (id) {
    if (typeof mixpanel === 'undefined') {
      return;
    }

    return mixpanel.identify(id); // eslint-disable-line
  },

  peopleSet: function (params) {
    if (typeof mixpanel === 'undefined') {
      return;
    }

    return mixpanel.people.set(params); // eslint-disable-line
  },

  reset: function () {
    if (typeof mixpanel === 'undefined') {
      return;
    }

    return mixpanel.reset(); // eslint-disable-line
  },

  track: function (event, data = {}) {
    if (typeof mixpanel === 'undefined') {
      return;
    }

    if (!data['Page Name']) {
      data['Page Name'] = getPageName(location.pathname);
    }

    setTimeout(() => mixpanel.track(event, data), 0); // eslint-disable-line
  },
};
